module.exports = __webpack_public_path__ + "static/media/logo.d52211aa.png";